import { render, staticRenderFns } from "./ManageWorkspaceForm.vue?vue&type=template&id=6c583a3e&"
import script from "./ManageWorkspaceForm.vue?vue&type=script&lang=js&"
export * from "./ManageWorkspaceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports